import DOMPurify from "dompurify";

import { cleanAndHighlightMarkdown } from "@/lib/utils";

const GRADE_TONE_PATTERN = /^(.+?)\s*\((green|blue|orange|red|purple|gray)\)$/i;

const GRADE_TONE_CLASSES = {
  green: {
    badge: "border-success-line bg-success-surface text-success",
    dot: "bg-success-solid",
  },
  blue: {
    badge: "border-info-line bg-info-surface text-info",
    dot: "bg-info-solid",
  },
  orange: {
    badge: "border-warning-line bg-warning-surface text-warning",
    dot: "bg-warning-solid",
  },
  red: {
    badge: "border-danger-line bg-danger-surface text-danger",
    dot: "bg-danger-solid",
  },
  purple: {
    badge: "border-premium-line bg-premium-surface text-premium",
    dot: "bg-premium-solid",
  },
  gray: {
    badge: "border-line bg-surface-sunken text-body",
    dot: "bg-gray-500",
  },
};

function decorateGradeCells(root) {
  root.querySelectorAll("table").forEach((table) => {
    table.classList.add("sabine-markdown-table");
  });

  root.querySelectorAll("thead th").forEach((heading) => {
    heading.setAttribute("scope", "col");
  });

  root.querySelectorAll("td").forEach((cell) => {
    const cellText = cell.textContent.replace(/\s+/g, " ").trim();
    const match = cellText.match(GRADE_TONE_PATTERN);
    if (!match) return;

    const [, label, rawTone] = match;
    const tone = rawTone.toLowerCase();
    const toneClasses = GRADE_TONE_CLASSES[tone];
    const badge = root.ownerDocument.createElement("span");
    const dot = root.ownerDocument.createElement("span");

    badge.className = `sabine-table-grade ${toneClasses.badge}`;
    badge.dataset.tone = tone;
    badge.setAttribute("aria-label", cellText);

    dot.className = `sabine-table-grade-dot ${toneClasses.dot}`;
    dot.setAttribute("aria-hidden", "true");

    badge.append(dot, label.trim());
    cell.replaceChildren(badge);
  });
}

export function renderAIChatMarkdown(content = "") {
  const sanitizedContent = DOMPurify.sanitize(
    cleanAndHighlightMarkdown(content, {
      openLinksInNewTab: true,
      linkifyCodeUrls: true,
    }),
    { ADD_ATTR: ["target", "rel"], RETURN_DOM: true },
  );

  sanitizedContent.querySelectorAll("a[target]").forEach((link) => {
    if (link.getAttribute("target")?.toLowerCase() === "_blank") {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    }
  });

  decorateGradeCells(sanitizedContent);

  return sanitizedContent.innerHTML;
}
